var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik } from 'formik';
import * as yup from 'yup';
import { createPassword as createPasswordAction } from '../../../actions/creators/createPassword';
import { confirmJoin as confirmJoinAction } from '../../../actions/auth/creators/Join';
import { getQueryVariable } from '../../../shared/sharedFunctions';
import { getProductId, getSourceId } from '../../../shared/domainUtils';
import Logo from '../../../assets/img/fp-logo.svg';
import Close from '../../../assets/img/close.svg';
var messages = defineMessages({
    create_password_title: {
        id: 'join.pick_password',
        defaultMessage: 'Придумайте пароль'
    },
    new_password_placeholder: {
        id: 'join.password',
        defaultMessage: 'Пароль'
    },
    repeat_password_placeholder: {
        id: 'join.password_repeat',
        defaultMessage: 'Повторите пароль'
    },
    save_button: {
        id: 'recharge.save',
        defaultMessage: 'Сохранить'
    },
    password_requirements: {
        id: 'validation.password_requirements',
        defaultMessage: 'Минимум 6 символов, включая 1 цифру и 1 заглавную букву'
    },
    loading_message: {
        id: 'loading',
        defaultMessage: 'Загрузка...'
    },
    activation_error_title: {
        id: 'join.errors.error',
        defaultMessage: 'Произошла ошибка! Попробуйте позже!'
    },
    activation_error_message: {
        id: 'forgot.errors.order_invalid',
        defaultMessage: 'Ссылка недействительна'
    },
    '-1': {
        id: 'promocode.error.not_found',
        defaultMessage: 'Промокод не найден'
    },
    '-2': {
        id: 'promocode.error.not_active',
        defaultMessage: 'Промокод не активен'
    },
    '-3': {
        id: 'promocode.error.used',
        defaultMessage: 'Промокод уже использован'
    },
    '-4': {
        id: 'promocode.error.not_available',
        defaultMessage: 'Промокод недоступен'
    },
    '-5': {
        id: 'promocode.error.default',
        defaultMessage: 'Промокод не активирован, попробуйте позже'
    },
    '-6': {
        id: 'promocode.error.identification_required',
        defaultMessage: 'Для использования данного промокода необходимо подтвердить свою личность. Просьба обратиться в онлайн чат службы поддержки.'
    },
    '-7': {
        id: 'promocode.error.expired',
        defaultMessage: 'Промокод просрочен и не может быть активирован'
    },
    '-11': {
        id: 'promocode.error.cannot_activate',
        defaultMessage: 'Активация промокода невозможна'
    },
    promocode_error_default: {
        id: 'promocode.error.default',
        defaultMessage: 'Промокод не активирован, попробуйте позже'
    },
});
var values = {
    Password: '',
    confpassword: '',
};
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            passwordNotMatch: false,
            joinType: undefined,
            showPass: false,
            isLoading: true
        };
        _this.onSubmit = function (values) {
            if (!values.Password || !values.confpassword) {
                return null;
            }
            var data = {
                'source': getSourceId(_this.props.countryCode),
                'product': getProductId(),
                'data': {
                    'gamblerId': _this.props.user.gamblerId,
                    'NewPassword': values.Password
                }
            };
            if (values.Password !== values.confpassword) {
                _this.setState({
                    passwordNotMatch: true
                });
            }
            else {
                _this.props.createPasswordAction(data);
            }
        };
        _this.togglePass = function () {
            _this.setState({
                showPass: !_this.state.showPass
            });
        };
        _this.onClose = function () {
            _this.props.history.push('/');
        };
        _this.validation = function (props) { return yup.object().shape({
            Password: yup.string()
                .matches(/(?=.*\d)(?=.*[a-zа-я])(?=.*[A-ZА-Я]).{6,}/, props.intl.formatMessage({ id: 'validation.password_requirements' }))
                .required(props.intl.formatMessage({ id: 'validation.required' })),
            confpassword: yup.string()
                .oneOf([yup.ref('Password'), null], props.intl.formatMessage({ id: 'validation.password_didnt_match' }))
                .required(props.intl.formatMessage({ id: 'validation.required' })),
        }); };
        return _this;
    }
    ChangePassword.prototype.componentDidMount = function () {
        var uid = getQueryVariable('uid');
        var joinType = getQueryVariable('joinType');
        if (!uid || !joinType) {
            this.setState({ isLoading: false });
            return;
        }
        var data = {
            'source': getSourceId(this.props.countryCode),
            'product': getProductId(),
            'joinType': +joinType,
            'confirmationData': {
                'uid': uid
            }
        };
        this.setState({
            joinType: joinType
        });
        this.props.confirmJoinAction(data);
    };
    ChangePassword.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.registration.passwordStatus !== nextProps.registration.passwordStatus &&
            nextProps.registration.passwordStatus === 0) {
            this.props.history.push('/');
        }
        if (Object.keys(nextProps.user).length !== 0 && nextProps.user.constructor === Object &&
            this.props.user.gamblerId !== nextProps.user.gamblerId) {
            this.setState({ isLoading: false });
        }
    };
    ChangePassword.prototype.render = function () {
        var _this = this;
        var _a = this.props, intl = _a.intl, registration = _a.registration;
        var passwordNotMatch = this.state.passwordNotMatch;
        var promoCodeError = registration.promoCodeError;
        var promoCodeErrorMessage = messages[promoCodeError] || messages.promocode_error_default;
        // if (isLoading && user.gamblerId === undefined) {
        //     return (
        //         <div className='new-modal auth-modal active'>
        //             <div className='new-modal__overlay' onClick={this.onClose}/>
        //             <div className='new-modal__content'>
        //                 <div className='new-modal__content-header'>
        //                     <img src={Logo} alt="Logo" className='logo' />
        //                     <h4 style={{color: '#777'}}><FormattedMessage {...messages.create_password_title}/></h4>
        //                     <img src={Close} alt="Close" className='new-modal__content-header-close' onClick={this.onClose} />
        //                 </div>
        //                 <div style={{ textAlign: 'center', padding: '20px' }}>
        //                     <div style={{color: '#777'}}><FormattedMessage {...messages.loading_message}/></div>
        //                 </div>
        //             </div>
        //         </div>
        //     );
        // }
        // if (!isLoading && user.gamblerId === undefined) {
        //     return (
        //         <div className='new-modal auth-modal active'>
        //             <div className='new-modal__overlay' onClick={this.onClose}/>
        //             <div className='new-modal__content'>
        //                 <div className='new-modal__content-header'>
        //                     <img src={Logo} alt="Logo" className='logo' />
        //                     <h4 style={{color: '#777'}}><FormattedMessage {...messages.activation_error_title}/></h4>
        //                     <img src={Close} alt="Close" className='new-modal__content-header-close' onClick={this.onClose} />
        //                 </div>
        //                 <div style={{ textAlign: 'center', padding: '20px' }}>
        //                     <div style={{color: '#777'}}><FormattedMessage {...messages.activation_error_message}/></div>
        //                 </div>
        //             </div>
        //         </div>
        //     );
        // }
        var props = {
            passwordNotMatch: passwordNotMatch,
            intl: intl
        };
        return (_jsxs("div", __assign({ className: 'new-modal register-modal active' }, { children: [_jsx("div", { className: 'new-modal__overlay', onClick: this.onClose }), _jsxs("div", __assign({ className: 'new-modal__content' }, { children: [_jsxs("div", __assign({ className: 'new-modal__content-header' }, { children: [_jsx("img", { src: Logo, alt: "Logo", className: 'logo' }), _jsx("h4", __assign({ style: { color: '#777' } }, { children: _jsx(FormattedMessage, __assign({}, messages.create_password_title)) })), _jsx("img", { src: Close, alt: "Close", className: 'new-modal__content-header-close', onClick: this.onClose })] })), promoCodeError ? (_jsx("div", __assign({ className: 'important', style: { textAlign: 'center', marginBottom: 10 } }, { children: intl.formatMessage(promoCodeErrorMessage) }))) : null, _jsx(Formik, { initialValues: values, validationSchema: function () { return _this.validation(props); }, onSubmit: this.onSubmit, render: function (_a) {
                                var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange, handleSubmit = _a.handleSubmit;
                                return (_jsxs("form", __assign({ onSubmit: handleSubmit }, { children: [_jsxs("div", __assign({ className: 'input' }, { children: [_jsx("input", { style: { backgroundColor: '#fff', color: '#777', border: '1px #C2C2BE solid' }, type: _this.state.showPass ? 'text' : 'password', autoComplete: 'off', name: 'Password', onChange: handleChange, value: values.Password, placeholder: intl.formatMessage(messages.new_password_placeholder) }), _jsx("div", { className: "show-pass ".concat(values.Password !== '' ? 'show-pass--visible' : '', " ").concat(_this.state.showPass ? 'no' : ''), onClick: _this.togglePass }), touched.Password && errors.Password &&
                                                    _jsx("div", __assign({ className: 'important' }, { children: errors.Password }))] })), _jsxs("div", __assign({ className: 'input' }, { children: [_jsx("input", { style: { backgroundColor: '#fff', color: '#777', border: '1px #C2C2BE solid' }, type: 'password', autoComplete: 'off', name: 'confpassword', onChange: handleChange, value: values.confpassword || '', placeholder: intl.formatMessage(messages.repeat_password_placeholder) }), touched.confpassword && errors.confpassword &&
                                                    _jsx("div", __assign({ className: 'important' }, { children: errors.confpassword }))] })), _jsx("div", __assign({ className: 'controls' }, { children: _jsx("button", __assign({ type: 'submit' }, { children: _jsx(FormattedMessage, __assign({}, messages.save_button)) })) }))] })));
                            } })] }))] })));
    };
    return ChangePassword;
}(React.Component));
ChangePassword.propTypes = {
    createPasswordAction: PropTypes.func.isRequired,
    confirmJoinAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
    registration: PropTypes.object.isRequired,
};
var mapStateToProps = function (state) { return ({
    user: state.auth.user,
    countryCode: state.application.get('client').country,
    registration: state.registration
}); };
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    createPasswordAction: createPasswordAction,
    confirmJoinAction: confirmJoinAction
}, dispatch); };
export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword)));



// WEBPACK FOOTER //
// ./src/components/shared/changePassword/index.js